// extracted by mini-css-extract-plugin
export default {"mainWrapper":"style_mainWrapper__VT9SQ","refWrapper":"style_refWrapper__7aY+m","sectionWrapper":"style_sectionWrapper__dxIQe"};